export const ROUTE_NIVEL_APROBACION_IMPORTACION = 'importacion:nivel-aprobacion'

export const ROUTE_TERMINOS_NEGOCIACION = 'importacion:incoterms'
